<script>
export default {
  name: 'FormInputWrapper',

  inheritAttrs: false,

  props: {
    focus: {
      type: Boolean,
      default: false,
    },

    error: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    // Prop para estilo personalizado
    round: {
      type: Boolean,
      default: false,
    },

    // Determina o tamanho do arredondamento
    rounded: {
      type: [String, Number],
      default: 'medium',
    },
  },

  computed: {
    computedClasses () {
      return {
        [this.$classes['has-focus']]: this.focus,
        [this.$classes['has-error']]: this.error,
        [this.$classes['is-disabled']]: this.disabled,
        [this.$classes['is-round']]: this.round,
        [this.$classes[`rounded-${this.rounded}`]]: this.round && this.rounded,
      }
    },
  },
}
</script>

<template>
  <div :class="[$classes['form-input-wrapper'], computedClasses]">
    <slot />
  </div>
</template>

<style module>
.form-input-wrapper {
  display: flex;
  border-bottom: 1px solid #A2A2A2;
  position: relative;
}

.form-input-wrapper.is-round {
  border-bottom: none;
  position: relative;
}

.has-error {
  border-color: #D14040;
}

.is-disabled {
  border-bottom-color: rgba(195, 198, 216, .3);
}
</style>
